import React from "react";
import { useNavigate } from "react-router-dom";
import "./SuccessPage.css";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-box">
        <h2 className="success-title">Спасибо за заявку</h2>
        <p className="success-text">
          Мы получили ваш запрос и уже работаем над ним. В ближайшее время
          свяжемся с вами для уточнения деталей. Если у вас есть вопросы, смело
          обращайтесь — мы всегда на связи!
        </p>
      </div>
      <button
        className="success-button"
        onClick={() => navigate("/")}
      >
        Вернуться назад
      </button>
    </div>
  );
};

export default SuccessPage;
